<template>
  <div tabindex="tabIndex" contenteditable="true" @input="update" @keydown="limitLength" @keyup="setFocus"></div>
</template>
<script>

export default {
  props: ['content', 'maxLength', 'tabIndex'],
  mounted: function () {
    this.$el.innerText = this.content
  },
  methods: {
    update(event) {
      this.$emit('update', event.target.innerText)
    },
    limitLength(event) {
      if (event.target.innerText.length >= this.maxLength || isNaN(String.fromCharCode(event.which))) {
        event.preventDefault()
      }
    },
    setFocus(event) {
      if (event.target.innerText.length > 0) {
        this.$emit('set-focus')
      }
    }
  }
}
</script>
<style scoped>
div[contenteditable] {
  outline: 0px solid transparent;
}
</style>
